<template>
    <div>
        <div class="top">
            <van-nav-bar title="留言" left-text="返回" left-arrow @click-left="onClickLeft"/>
        </div>
        <div class="writeBox">
            <van-cell-group>
                <van-field
                    v-model="message"
                    type="textarea"
                    placeholder="欢迎参与交流,留言将由作者筛选后公开显示"
                    rows="6"
                    autosize
                />
            </van-cell-group>
        </div>
        <div class="submitBtn" @click="formSubmit">
            <button>提交留言</button>
        </div>
    </div>
</template>
<script>
import { httpPostRequest } from "../../axios/post";
import { Dialog } from 'vant';
export default {
    data(){
        return{
            message:'',
            newsId:this.$store.state.newsId
        }
    },
    methods:{
        // 返回上一页
        onClickLeft(){
            this.$router.go(-1)
        },
        // 提交留言
        formSubmit(){
            var liuyan=this.message;
            var newsId=this.newsId;
            httpPostRequest({
                route: 2,
                type: "post",
                url: "/news/add_comment",
                data: {user_id: this.$store.state.userInfo.user_id,article_id:newsId,content:liuyan}
            })
            .then(response => {
                if(response.code === 1){
                    Dialog({ message: '留言成功' });
                    this.$router.go(-1)
                }
            })
        }
    },
    mounted(){

    }    
}
</script>
<style>
body{
    height: 100%;
    background: #f2f2f2;
}
.submitBtn button{
    display: block;
    margin: 0 auto;
    border: none;
    width: 70vw;
    height: 3rem;
    font-size: 1rem;
    line-height: 3rem;
    background: #06b2b6;
    color: #fff;
    border-radius: 1.5rem;
    margin-top: 2rem;
}
</style>

